import React from 'react';

const YearSelector = ({
  years = [],
  selected = 0,
  onNextClick,
  onPrevClick,
  onYearClick,
}) => (
  <div className="c-History__timeline">
        <img
          className="c-History__arrow-left"
          onClick={onPrevClick}
          src="/themes/app/assets/images/timeline-left-arrow.svg"
         />
    <div className="c-History__years">

      <span className="c-History__line"></span>

      {years.map((year, idx) => (
        <button
          key={idx}
          className={idx === selected ? 'c-History__year' : 'c-History__year u-hidden-sm'}
          onClick={() => onYearClick(idx)}
        >
          {year}
          <img src={idx === selected ? '/themes/app/assets/images/year-marker-selected.svg' : '/themes/app/assets/images/year-marker.svg'}
            key={idx}
            className="c-History__year-marker"
            onClick={() => onYearClick(idx)}
          >
          </img>
        </button>
      ))}
    </div>
    <img
      className="c-History__arrow-right"
      onClick={onNextClick}
      src="/themes/app/assets/images/timeline-right-arrow.svg"
    />
  </div>
);

export default YearSelector;



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/history/js/YearSelector.js